import components from './components.js';
import boards from './boards.js';
import elements from './elements.js';
import notes from './notes.js';
import jumpers from './jumpers.js';
import branches from './branches.js';
import conditions from './conditions.js';
import connections from './connections.js';
import attributes from './attributes.js';
import assets from './assets.js';
import variables from './variables.js';
import comments from './comments.js';
import { has } from '../../../utils.js';

const state = {};

const getters = {
  /**
   * Returns the number of elements, branches, jumpers and components in the project (excluding containers)
   */
  getItemCount(state) {
    return (
      Object.keys(state.elements.byId).length +
      Object.keys(state.jumpers.byId).length +
      Object.keys(state.branches.byId).length +
      Object.values(state.components.byId).filter(c => !has(c, 'children'))
        .length +
      Object.values(state.comments.byId).filter(
        c => !has(c, 'root') && has(c, 'children')
      ).length
    );
  },

  /**
   * Returns the node with id based on the type provided
   * @param {string} id The Node ID
   * @param {string} type The Node Type (elements, components, etc.)
   * @returns {pbject} The node with ID of the type provided
   */
  getNodeOfType(state) {
    return (id, type) => state[type].byId[id];
  },
};

const actions = {};

const mutations = {};

const modules = {
  components,
  boards,
  elements,
  notes,
  jumpers,
  branches,
  conditions,
  connections,
  attributes,
  assets,
  variables,
  comments,
};

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
  modules,
};

export default module;
